module.exports = __webpack_public_path__ + "public/img/yicuihui.3dc53081.png";